export const breadcrumbs = [
  { name: 'Финансы', href: '/invoices' },
  { name: 'Счета', href: '' }
]

export const tabsOptions = [
  { key: '0', title: 'Все', value: undefined },
  { key: '1', title: 'Неоплаченные', value: false },
  { key: '2', title: 'Оплаченные', value: true }
]

export const firstPage = 1

export const emptyListTitle = 'Пока тут пусто'

export const emptyListText = [
  'Когда у вас появятся счета, они будут храниться здесь',
  'Когда неоплаченные счета появятся, они будут храниться здесь',
  'Когда оплаченные счета появятся, они будут храниться здесь'
]

export const wrongNumberFormat = 'Некорректный формат числа'
